export type ChooserWithTableAction = 'continue' | 'abort' | 'dismiss'

/**
 * Swing `UIMessages.showChooserWithTable`: the table is informational.
 * «Продолжить» → "ok", «Отменить» → "cancel", close / Escape → null.
 */
export function resolveChooserWithTableChoice(action: ChooserWithTableAction): string | null {
  if (action === 'continue') return 'ok'
  if (action === 'abort') return 'cancel'
  return null
}
